<div *ngIf="modelData">
<ng-template #content let-modal class="container-youtube-popup">
  <div class="modal-body">
    <button type="button" class="btn-close-popup" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
    <iframe width="100%" height="100%" [src]="videoUrl1" frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  </div>
</ng-template>


<header class="contenedor">
  <div class="topbar"></div>
  <div id="logo-hp">
    <img src="assets/img/logo_hp.svg" alt="Logo HP">
  </div>


  <main class="contenedor">
    <!--    DIF #1   -->
    <section>
      <img class="lifestyle-dif" src="{{modelData.headerDesktopUrl}}">
      <a id="play-video" style="
    position: absolute;
    z-index: 999;
    text-align: center;
    margin-left: auto;
    margin-right: auto;
" (click)="open(content)" *ngIf="videoUrl1"><img src="assets/img/01_banners/play.svg" width="80px" alt="Botón Play Video"></a>
    </section>
  </main>
 <!-- <div id="banner-home" class="desktop" [ngStyle]="{'background-image': 'url('+modelData.headerDesktopUrl+')'}">
    <a id="play-video" (click)="open(content)" *ngIf="videoUrl1"><img src="assets/img/01_banners/play.svg" alt="Botón Play Video"></a>
  </div>

  <div id="banner-home" class="mobile" [ngStyle]="{'background-image': 'url('+modelData.headerMobileUrl+')'}">
    <a id="play-video" (click)="open(content)" *ngIf="videoUrl1"><img src="assets/img/01_banners/play.svg" alt="Botón Play Video"></a>
  </div>-->

  <div class="descrip-producto-principal">
    <h1>{{modelData.nameFirstLine}}</h1>
    <h1>{{modelData.nameSecondLine}}</h1>
    <p style="margin-top:17px">{{modelData.introduccion}}</p>
  </div>
</header>

<main class="contenedor">
  <!--    DIF #1   -->
  <section *ngFor="let diferenciador of modelData.diferenciadores">
    <img class="lifestyle-dif" src="{{diferenciador.imagenBody}}" alt="Trabaja todo el día. Disfruta todo el tiempo.">
    <img class="icono-dif" src="{{diferenciador.imagen}}" alt="Batería">
    <div class="textos-dif">
      <h2>{{diferenciador.titulo}}</h2>
      <p>{{diferenciador.descripcion}}</p>
    </div>
  </section>

</main>

<section class="contenedor"  style="margin-top:80px" *ngIf="videoUrl2">
  <iframe width="100%" height="500px" [src]="videoUrl2" frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</section>
<section class="contenedor"   *ngIf="videoUrl3">
  <iframe width="100%" height="500px" [src]="videoUrl3" frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</section>
<section class="contenedor"   *ngIf="videoUrl4">
  <iframe width="100%" height="500px" [src]="videoUrl4" frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
</section>

<!--  FICHA TÉCNICA -->

<section class="contenedor"  style="margin-top:80px">
  <h2 class="ft-h2">Ficha Técnica</h2>
  <div id="ficha-tecnica">
    <div class="contenedor-specs" *ngFor="let spec of modelData.allSpecs" [hidden]="!spec.imagen">
      <img src="{{spec.imagen}}" alt="Procesador">
      <h3>{{spec.label}}</h3>
      <p>{{spec.value}}</p>
    </div>
  </div>
</section>

<!--  GALERÍA DE IMÁGENES -->

<section class="gl-contenedor especificacionesSection" style="margin-top:100px">
  <h2 class="gl-h2">Galería</h2>
  <div class="galeria-img">
    <input type="radio" *ngFor="let img of modelData.galeria; let indexDif = index" id="{{indexDif}}"
           name="image-slide" hidden/>
    <div class="slide">
      <div class="item-slide" *ngFor="let img of modelData.galeria">
        <img src="{{img.url}}">
      </div>
    </div>
    <div class="pagination">
      <label class="pagination-item"   *ngFor="let img of modelData.galeria;let indexDif = index" for="{{indexDif}}" (click)="setImgActive(indexDif)" [ngClass]="{'active': imgActive==indexDif}">
        <img src="https://fichashppervasive.blob.core.windows.net/imagenes/thumb-{{img.name}}">
      </label>
    </div>
  </div>
</section>

<!--  ESPECIFICACIONES PRINCIPALES -->

<section class="ep-contenedor especificacionesSection">
  <h2>Especificaciones Principales</h2>

  <div class="tabla-esp-prin" [ngClass]="{'bg-tabla-oscuro': 0 === index % 2, 'bg-tabla-border': 0 != index % 2}"
       *ngFor="let spec of modelData.allSpecs;let index = index">
    <div class="tabla-izq"><p>{{spec.label}} </p></div>
    <div class="tabla-der"><p>{{spec.value}}</p></div>
  </div>

</section>


<footer id="footer" class="ep-contenedor">
  <p>{{modelData.legales}}</p>
</footer>


</div>
